import { Table, TableBody } from "@mui/material";
import { Category as ProfileTypeIcon } from "@mui/icons-material";
import type { VendorCategory } from "@/services/vendorCategories";
import type { VendorProfileFacility } from "../types";
import { SectionCard } from "../components/SectionCard";
import { FieldRow } from "../components/FieldRow";
import { formatText } from "../utils/format";
import { majorLabel, subLabel } from "../utils/vendorCategories";

type Props = {
  profile: VendorProfileFacility;
  categories?: VendorCategory[];
};

export function VendorProfileTypeSection({ profile, categories }: Props) {
  return (
    <SectionCard icon={<ProfileTypeIcon fontSize="small" />} title="Vendor Profile Type">
      <Table size="small">
        <TableBody>
          <FieldRow
            label="Super Category"
            value={formatText(majorLabel(categories, profile.super_category))}
          />
          <FieldRow
            label="Sub Category"
            value={formatText(
              subLabel(categories, profile.super_category, profile.sub_category),
            )}
          />
        </TableBody>
      </Table>
    </SectionCard>
  );
}

export default VendorProfileTypeSection;
